export default "<div [@hover]=\"state\" (mouseenter)=\"state = 'in'\" (mouseleave)=\"state = 'out'\">\n  <ng-content></ng-content>\n</div>\n"